import React from 'react';
import { islamicCalculators_En } from '../ConstantsEN';
import SharedHelmet from '../Helmet';
const TITLE = 'Zakat Calculators - Free Calculators for Calculating Zakat on Wealth and Sharia Assets';
const DESCRIPTION = 'Explore our collection of free Zakat calculators, including calculators for calculating Zakat on wealth, alms, and Sharia assets according to Islamic rules.';
const KEYWORDS = 'Zakat calculators, free calculators, wealth Zakat calculator, gold Zakat calculator, silver Zakat calculator, fruit Zakat calculator, trade items Zakat calculator, livestock Zakat calculator, gold carat conversion calculator';
const NOTE = 'If you know of or wish to add other calculators, please contact us via email at info@do-calculate.com. We will be happy to add them! :)';
const OG_URL = 'https://do-calculate.com/en/zakat-calculators';
function CalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION}</p>
                </div>
                <div className="alert alert-info" role="alert">
                    <u><p>{NOTE}</p></u>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >Calculator</th>
                        <th >Description</th>
                    </tr>
                </thead>
                <tbody>
                    {islamicCalculators_En.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
